// extracted by mini-css-extract-plugin
export default {"image":"ConfirmDialog__image__qLRuB","textCenter":"ConfirmDialog__textCenter__gr5N2","close":"ConfirmDialog__close__i9MJI","headingPadding":"ConfirmDialog__headingPadding__WzFHu","primaryButton":"ConfirmDialog__primaryButton__aF2Lb"};
    if(module.hot) {
      // 1753447559656
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  